module.exports = __webpack_public_path__ + "static/8-ee93a933046f2f4647517ab4d9921c2d.jpg";